module.exports = "<i class=\"fa fa-lg fa-{2}\"></i> &nbsp; {1}";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/toast-templates/iconized.html
// module id = 441
// module chunks = 0